<template>
    
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <Toast/>
                <Toolbar class="p-mb-4">
                    <template slot="left">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field col-md-2">
                                <label for="anio">Año</label>
                                <Dropdown id="anio" 
                                    style="width:120px;"
                                    :filter="false" 
                                    :options="anioLista" 
                                    v-model="anioSeleccionado"
                                    optionLabel="anio" 
                                    dataKey="id"
                                    placeholder="Seleccionar Año">
                                </Dropdown>
                            </div>
                            <div class="p-field col-md-2" style="margin-left: 10px">
                                <label for="mes">Mes</label>
                                <Dropdown id="mes" 
                                    style="width:120px;"
                                    :filter="false" 
                                    :options="mesLista" 
                                    v-model="mesSeleccionado"
                                    optionLabel="mes" 
                                    dataKey="id"
                                    placeholder="Seleccionar Mes">
                                </Dropdown>
                            </div>
                            <div class="p-field col-md-2" style="margin-left: 10px">
                                <label for="buscar">&nbsp;&nbsp;</label>
                                <div class="col-md-2">
                                    <Button id="buscar" icon="pi pi-search" style="width:100px;" class="p-button-primary" @click='verReporte()' />
                                </div>							
                            </div>
                        </div>
                    </template>
                </Toolbar>
                <div>
                    <embed :src="pdfRuta" type="application/pdf" width="100%" height="600px" />
                </div>
            </div>
        </div>
        <DialogProgreso
            :showProgreso="showProgreso"
            :titulo="mensajeCargando">
        </DialogProgreso>
    </div>
</template>
<script>
import AnioService from "../../service/administracion/AnioService";
import MesService from "../../service/administracion/MesService";
import Swal from 'sweetalert2';
import PlanillaService from "../../service/administracion/PlanillaService";
import DialogProgreso from "../componentesglobales/DialogoProgreso.vue";
export default {
    data() {
        return {
            anioLista: [],
			anioSeleccionado: {},
			mesLista: [],
			mesSeleccionado: {},
            pdfRuta: null,
            showProgreso: null,
            mensajeCargando: null
        };
    },
    planillaService: null,
    anioService: null,
	mesService: null,
    created() {
        this.anioService = new AnioService();
		this.mesService = new MesService();
        this.planillaService = new PlanillaService();
    },
    mounted() {
        this.cargarAnio();
		this.cargarMes();
    },
    components: {
		'DialogProgreso': DialogProgreso
	},
    methods: {
        cargarAnio(){
			this.anioLista = [];
			this.anioService.buscaractivos().then( response => {
				this.anioLista = response.data;
			}).catch( error => {
				console.log(error);
			});
		},

		cargarMes(){
			this.mesLista = [];
			this.mesService.buscaractivos().then( response => {
				this.mesLista = response.data;
			}).catch( error => {
				console.log(error);
			});
		},

        verReporte(){
            if(Object.keys(this.anioSeleccionado).length == 0){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar año", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
			if(Object.keys(this.mesSeleccionado).length == 0){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar mes", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
            this.mensajeCargando = "Generando reporte";
            this.showProgreso = true;
            this.planillaService.imprimirConsolidadoConsumo(this.mesSeleccionado.id, this.anioSeleccionado.id, this.mesSeleccionado.mes, this.anioSeleccionado.anio).then(response => {
                var headers = response.headers;
                var blob = new Blob([response.data],{type:headers['content-type']});
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                this.showProgreso = false;
                this.pdfRuta = link.href;
            }).catch(() => {
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Documento no existe", icon: 'warning', showConfirmButton: true, timer: 6000});
                this.showProgreso = false;
            });
        }
    }
};
</script>